export const CIRCUIT_PYTHON_HELP_URL =
    'https://pyranger.com/guides/circuitpython-troubleshooting';

export const NAV_MODAL_ID = 'nav-modal';
